import { TFunctionNonStrict } from 'i18next';

export const translateWorkerStatus = (
  status: string,
  t: TFunctionNonStrict<'web-common', undefined>
) => {
  switch (status) {
    case 'accepted':
      return t('status.accepted');
    case 'rejected':
      return t('status.rejected');
    case 'pending':
      return t('status.pending');
    case 'cancelled':
      return t('status.cancelled');
    case 'awaitingActivation':
      return t('status.awaiting_activation');
    case 'cancelledFullShift':
      return t('status.cancelled_full_shift');
    default:
      return status;
  }
};
